import type { ComputedRef } from 'vue';
import { computed } from 'vue';

type Behavior = 'suggest' | 'search';

export function useSearchBehavior(input: ComputedRef<string>) {
  const behavior = computed<Behavior>(() => (input.value.trim() === '' ? 'suggest' : 'search'));
  const isSuggest = computed(() => behavior.value === 'suggest');
  const isSearch = computed(() => behavior.value === 'search');

  return {
    isSuggest,
    isSearch
  };
}
